/* TDT · Servicios — cinta de imágenes infinita */
if (!customElements.get('tdt-marquee')) {
  class TdtMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.tdt-sv__track');
      this.original = this.querySelector('.tdt-sv__group');
      if (!this.track || !this.original) return;

      this.speed = parseFloat(this.dataset.speed) || 50;
      this.onResize = this.debounce(() => this.build(), 200);

      this.build();
      window.addEventListener('resize', this.onResize);

      // Recalcular cuando carguen las imágenes (el ancho puede cambiar)
      this.original.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', this.onResize, { once: true });
      });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.classList.toggle('is-running', entry.isIntersecting);
        });
        this.observer.observe(this);
      } else {
        this.classList.add('is-running');
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      this.observer?.disconnect();
    }

    build() {
      // Quita clones previos
      this.track.querySelectorAll('.tdt-sv__group[aria-hidden]').forEach((g) => g.remove());

      const groupWidth = this.original.getBoundingClientRect().width;
      if (!groupWidth) return;

      // Clones suficientes para cubrir la pantalla + un grupo extra (bucle sin saltos)
      const copies = Math.max(1, Math.ceil(this.offsetWidth / groupWidth)) + 1;
      for (let i = 1; i < copies; i++) {
        const clone = this.original.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('role');
        clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
        this.track.appendChild(clone);
      }

      // Duración según la velocidad elegida (px/segundo)
      this.style.setProperty('--tdt-sv-shift', groupWidth + 'px');
      this.style.setProperty('--tdt-sv-duration', (groupWidth / this.speed).toFixed(2) + 's');

      // Reinicia la animación con las nuevas medidas
      this.track.style.animation = 'none';
      void this.track.offsetWidth;
      this.track.style.animation = '';
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  customElements.define('tdt-marquee', TdtMarquee);
}
